import { Icon } from "@core/components/Icon";
import { LinkBehaviour } from "@core/components/LinkBehaviour";
import type { SafeHtmlAttributes } from "@core/index";

import { UiCheckIcon } from "@jti/brand-icons/ui-check";

import styles from "./MenuItem.module.scss";

type MenuItemBaseProps = {
  label: string;
  isSelected?: boolean;
};

export type MenuItemLinkProps = MenuItemBaseProps & {
  href: string;
  nativeBehaviour?: boolean;
} & SafeHtmlAttributes<HTMLAnchorElement>;

export type MenuItemButtonProps = MenuItemBaseProps & {
  href?: never;
  disabled?: boolean;
} & SafeHtmlAttributes<HTMLButtonElement>;

export type MenuItemProps = MenuItemLinkProps | MenuItemButtonProps;

export const MenuItem = (props: MenuItemProps) => {
  const { label, isSelected = false } = props;

  const content = (
    <>
      <span className={styles.label}>{label}</span>
      {isSelected && <Icon icon={UiCheckIcon} size="xs" className={styles.checkIcon} />}
    </>
  );

  if (typeof props.href === "string") {
    const { ...linkProps } = props;

    return (
      <LinkBehaviour {...linkProps} role="menuitem" className={styles.menuItem}>
        {content}
      </LinkBehaviour>
    );
  }

  const { ...buttonProps } = props;

  return (
    <button {...buttonProps} role="menuitem" type="button" className={styles.menuItem}>
      {content}
    </button>
  );
};
